import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'access-denied',
    loadChildren: () =>
      import('./shared/components/access-denied/access-denied.module').then(
        (m) => m.AccessDeniedModule
      ),
  },
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./features/dashboard/dashboard.module').then((m) => m.DashboardModule),
  // },
  // {
  //   path: 'boards', loadChildren: () => import('./features/boards/boards.module').then(m => m.BoardsModule)
  // },
  {
    path: '',
    loadChildren: () =>
      import('./features/home-alt/home-alt.module').then((m) => m.HomeAltModule),
  },
  // {
  //   path: 'calendar', loadChildren: () => import('./features/congress-calendar/congress-calendar.module').then(m => m.CongressCalendarModule),
  // },
  {
    path: 'pb', loadChildren: () => import('./features/powerbi-container/powerbi-container.module').then(m => m.PowerbiContainerModule)
  },
  {
    path: 'whats-new-settings',
    loadChildren: () => import('./modules/executive-orders/executive-order.module').then(m => m.ExecutiveOrdersModule)
  },
  {
    path: 'app-settings',
    loadChildren: () => import('./features/app-settings/app-settings.module').then(m => m.AppSettingsModule)
  },
  // {
  //   path: 'hearings-uploads',
  //   loadChildren: () => import('./modules/hearings-uploads/hearings-uploads.module').then(m => m.HearingsUploadsModule)
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
